import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute'

import MetaFieldsGridLayout from './containers/Grid';

export default function MetaFieldLayout() {
  return <Router>
    <PrivateRoute path='/settings/meta-fields' component={MetaFieldsGridLayout} />
  </Router>
}
